import React from 'react';
import PropTypes from 'prop-types';

import { PUBLIC_SITE_URL } from 'utils/restapi';

import './ViewLiveButton.scss';

const ViewLiveButton = ({ me }) => {
  if (!me) return null;

  return (
    <a
      className="view-live-button__component"
      href={`${PUBLIC_SITE_URL}/${me.username}`}
      target="_blank"
      rel="noreferrer noopener"
    >
      VIEW LIVE
    </a>
  );
};

ViewLiveButton.propTypes = {
  me: PropTypes.object,
};

ViewLiveButton.defaultProps = {
  me: null,
};

export default ViewLiveButton;
